import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { SapService } from 'src/app/api/sap.service';
import { variableGlobal } from 'src/app/global.enum';
import { Columns, Config, DefaultConfig, APIDefinition, API } from 'ngx-easy-table';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { CrearListaMaterialesComponent } from './crear-lista-materiales/crear-lista-materiales.component';
import { IntranetoldService } from 'src/app/api/intranetold.service';

@Component({
  selector: 'app-lista-materiales',
  templateUrl: './lista-materiales.component.html',
  styleUrls: ['./lista-materiales.component.css']
})
export class ListaMaterialesComponent implements OnInit {


  @ViewChild('table', { static: true }) table: APIDefinition;
  @ViewChild('frmAccion', { static: true }) frmAccion: TemplateRef<any>;
  public configuration: Config;
  public columns: Columns[];
  public columns2: Columns[];
  AllMaestroArticulos: any;

  data:any;
  articuloeliminar: any;
  administrador: any;
  nuevosListaArticulos:any;

  private setClass(name: string): void {
    if (this.table && this.table.apiEvent) {
      this.table.apiEvent({
        type: API.setTableClass,
        value: name,
      });
    }
  }


  eliminarMT(row) {
    this.articuloeliminar = row
  }

  async confirmareliminar() {
    await this._sap.EliminarMT(this.articuloeliminar)
    location.reload()
  }

  constructor(
    private modalService: NgbModal,
    private _sap: SapService,
    private _dbService: NgxIndexedDBService,
    private _api:IntranetoldService,
  ) { }

  ngOnInit(): void {
    this._dbService.getByID("general", "login").subscribe((res: any) => {
      
      if (typeof res === 'object' && res !== null) {
        this.administrador = res.datos.login.OITM_SAP;
        
      }
    });
    this.cargaInicial();
  }


  async cargaInicial() {

    var data:any = await this._api.getQueryAll();
    var query:string = "";

    await data.objeto.forEach(element => {
      // if (element.NOMBRE == "stockComercial") {
        if(element.NOMBRE == "ListaMaterialesInventario") { //stockComercial
        query = element.CONSULTA;
      }
    });

    this.data = await this._api.GetNotFileQuery(query);
    this.data = this.data.objeto;

    
    

    await data.objeto.forEach(element => {
      // if (element.NOMBRE == "stockComercial") {
        if(element.NOMBRE == "nuevoListaMateriales") { //stockComercial
        query = element.CONSULTA;
      }
    });

    this.nuevosListaArticulos = await this._api.GetNotFileQuery(query);
    this.nuevosListaArticulos = [...this.nuevosListaArticulos.objeto];
    


    this.columns = [

      { key: 'Code', title: 'N° Artículo' },
      { key: 'Name', title: 'Descripción' },
    //  { key: 'ItmsGrpNam', title: 'Grupo de artículos' },
    //  { key: 'OnHand', title: 'Stock' },
    //  { key: 'U_IND_CATEGORIA2', title: 'Familia' },
    //  { key: 'U_IND_CATEGORIA3', title: 'Sub-Familia' },
    //  { key: 'U_IND_SWW', title: 'Código Antiguo' },
      { key: '', title: 'Asignar', cellTemplate: this.frmAccion },

    ];

    this.columns2 = [

      { key: 'ItemCode', title: 'N° Artículo' },
      { key: 'ItemName', title: 'Descripción' },

    ];

    if (variableGlobal.ESTILO_EASY_TABLE) {
      this.setClass(variableGlobal.ESTILO_EASY_TABLE);
    }


    this.configuration = {
      ...DefaultConfig,
      searchEnabled: true,
      detailsTemplate: true,
      paginationRangeEnabled: true,
      paginationEnabled: true,
      horizontalScroll: true,
      resizeColumn: false,
      orderEnabled: true,
      rowReorder: false,
      columnReorder: false,
      fixedColumnWidth: true,
    };
  }

  crearListaMateriales(row) {

    let newData = {
         "Code": row.ItemCode,
         "TreeType": "",
         "PriceList": 0,
         "Quantity": null,
         "CreateDate": "",
         "UpdateDate": "",
         "Transfered": false,
         "DataSource": "",
         "UserSign": 0,
         "SCNCounter": null,
         "DispCurr": null,
         "ToWH": "",
         "Object": "",
         "LogInstac": null,
         "UserSign2": null,
         "OcrCode": "",
         "HideComp": false,
         "OcrCode2": "",
         "OcrCode3": "",
         "OcrCode4": "",
         "OcrCode5": "",
         "UpdateTime": 0,
         "Project": null,
         "PlAvgSize": 0,
         "Name": row.ItemName,
         "CreateTS": 0,
         "UpdateTS": 0,
         "AtcEntry": null,
         "Attachment": null,
         "iTT1": [],
         "iTT2": [],
         "userFields": []
     };

    let ngbModalOptions: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
      size: "xl",
      windowClass: 'full-width-modal',
      modalDialogClass: variableGlobal.CLASS_MODAL_BG,
    };

    const modalRef = this.modalService.open(CrearListaMaterialesComponent, ngbModalOptions);
    modalRef.componentInstance.modalReference = modalRef;
    modalRef.componentInstance.crear = true;
    modalRef.componentInstance.data = newData;
    modalRef.result.then(async (data) => { });

  }

  async editarMaestroArticulo(articulo) {

    let ngbModalOptions: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
      size: "xl",
      modalDialogClass: variableGlobal.CLASS_MODAL_BG,
    };

    const modalRef = this.modalService.open(CrearListaMaterialesComponent, ngbModalOptions);
    modalRef.componentInstance.modalReference = modalRef;
    modalRef.componentInstance.crear = false;
    modalRef.componentInstance.data = articulo;
    modalRef.result.then(async (data) => { });

  }

}
